import { useSelector } from 'react-redux';

export const usePermissions = () => {
  const authReducer = useSelector((state) => state.AuthReducer);
  const { assignedPermissionsForCurrentUser } = authReducer;

  const { positionPermissions, teamPermissions } =
    assignedPermissionsForCurrentUser || {};

  const isPermissionsLoaded = assignedPermissionsForCurrentUser !== null;

  const hasPermission = (permissionCodename) => {
    const noPermissionsAssigned =
      isPermissionsLoaded &&
      (positionPermissions?.length === 0 || !positionPermissions) &&
      (teamPermissions?.length === 0 || !teamPermissions);

    if (noPermissionsAssigned) return true;

    const permissions = [
      ...(positionPermissions || []),
      ...(teamPermissions || []),
    ];

    return permissions.some(
      (permission) => permission.codename === permissionCodename,
    );
  };

  return {
    isPermissionsLoaded,
    positionPermissions,
    teamPermissions,
    hasPermission,
  };
};
